import React from 'react';
import { Mic, MicOff } from 'lucide-react';

/**
 * Small mic button placed in a field's label row to dictate that field.
 * Idle = outline + Mic icon; active (this field is recording) = red + MicOff.
 * Disabled with an explanatory tooltip when the browser has no Web Speech API.
 */
export default function VoiceInputButton({ fieldKey, listeningField, supported, onClick, disabled }) {
    const isListening = supported && listeningField === fieldKey;
    const title = !supported
        ? 'Voice input needs Chrome or Edge'
        : isListening
            ? 'Listening… click to stop'
            : 'Dictate this field';

    return (
        <button
            type="button"
            className={`btn btn-sm py-0 ${isListening ? 'btn-danger' : 'btn-outline-secondary'}`}
            onClick={onClick}
            disabled={!supported || disabled}
            title={title}
            aria-label={title}
            aria-pressed={isListening}
        >
            {isListening ? <MicOff size={16} /> : <Mic size={16} />}
        </button>
    );
}
